let _counter = BigInt(0)
function _getNextScopeValue () {
  return BigInt(1) << _counter++
}
/* OpenID Connect Standard Scopes */
export const zero = BigInt(0)
export const OpenidScope = _getNextScopeValue()
export const ProfileScope = _getNextScopeValue()
export const PhoneScope = _getNextScopeValue()
export const EmailScope = _getNextScopeValue()

/* OpenID Connect Standard Scopes - Unused */
export const AddressScope = _getNextScopeValue()

/* Idonia specific scopes */
export const IdoniaBasicUserInfoScope = _getNextScopeValue()

export const SingleFolderAddIdoniaScope = _getNextScopeValue()
export const SingleFolderReadIdoniaScope = _getNextScopeValue()
export const SingleFolderEditIdoniaScope = _getNextScopeValue()
export const SingleFolderShareIdoniaScope = _getNextScopeValue()
export const SingleFolderDeleteIdoniaScope = _getNextScopeValue()

export const MySpaceAddIdoniaScope = _getNextScopeValue()
export const MySpaceReadIdoniaScope = _getNextScopeValue()
export const MySpaceEditIdoniaScope = _getNextScopeValue()
export const MySpaceShareIdoniaScope = _getNextScopeValue()
export const MySpaceDeleteIdoniaScope = _getNextScopeValue()

export const AllFilesAddIdoniaScope = _getNextScopeValue()
export const AllFilesReadIdoniaScope = _getNextScopeValue()
export const AllFilesEditIdoniaScope = _getNextScopeValue()
export const AllFilesShareIdoniaScope = _getNextScopeValue()
export const AllFilesDeleteIdoniaScope = _getNextScopeValue()

export const PublicUrlIdoniaScope = _getNextScopeValue()

/* Idonia connect cloud scopes */

export const AcquireIdoniaConnectScope = _getNextScopeValue()
export const AcquisitionIdoniaConnectScope = _getNextScopeValue()

export const FilesAddIdoniaConnectScope = _getNextScopeValue()
export const FilesReadIdoniaConnectScope = _getNextScopeValue()
export const FilesEditIdoniaConnectScope = _getNextScopeValue()
export const FilesShareIdoniaConnectScope = _getNextScopeValue()
export const FilesDeleteIdoniaConnectScope = _getNextScopeValue()

export const NotifyIdoniaConnectScope = _getNextScopeValue()

export const RemoteSignIdoniaConnectScope = _getNextScopeValue()

export const ConfigurationModifyIdoniaConnectScope = _getNextScopeValue()

/* Idonia groups scopes TODO */
/* Idonia organization scopes TODO */

/* Idonia admin scopes */
export const AccountEditIdoniaAdminScope = _getNextScopeValue()
export const OrganizationEditIdoniaAdminScope = _getNextScopeValue()
export const WhitelabelEditIdoniaAdminScope = _getNextScopeValue()
export const LicenseReadIdoniaAdminScope = _getNextScopeValue()
export const LicenseEditIdoniaAdminScope = _getNextScopeValue()
export const ConnectReadIdoniaAdminScope = _getNextScopeValue()
export const ConnectEditIdoniaAdminScope = _getNextScopeValue()
export const StatisticsReadIdoniaAdminScope = _getNextScopeValue()
export const RoleEditIdoniaAdminScope = _getNextScopeValue()
/* Idonia private scopes */
export const AccountModifyIdoniaScope = _getNextScopeValue()
export const IdoniaPrivateUserInfoScope = _getNextScopeValue()

/* Idonia platform private scopes */
export const AdminIdoniaScope = _getNextScopeValue()

/* Special autogrant scope */
export const AutograntScope = _getNextScopeValue()

/* Special invalid scope */
export const InvalidScope = _getNextScopeValue()

export const SingleFolderFullAccessIdoniaScope = SingleFolderAddIdoniaScope |
  SingleFolderReadIdoniaScope |
  SingleFolderEditIdoniaScope |
  SingleFolderShareIdoniaScope |
  SingleFolderDeleteIdoniaScope

export const MySpaceFullAccessIdoniaScope = SingleFolderFullAccessIdoniaScope |
  MySpaceAddIdoniaScope |
  MySpaceReadIdoniaScope |
  MySpaceEditIdoniaScope |
  MySpaceShareIdoniaScope |
  MySpaceDeleteIdoniaScope

export const AllFilesFullAccessIdoniaScope = MySpaceFullAccessIdoniaScope |
  AllFilesAddIdoniaScope |
  AllFilesReadIdoniaScope |
  AllFilesEditIdoniaScope |
  AllFilesShareIdoniaScope |
  AllFilesDeleteIdoniaScope

export const FilesFullAccessIdoniaConnectScope = FilesAddIdoniaConnectScope |
  FilesReadIdoniaConnectScope |
  FilesEditIdoniaConnectScope |
  FilesShareIdoniaConnectScope |
  FilesDeleteIdoniaConnectScope

export const IdoniaConnectScope = AcquireIdoniaConnectScope |
  FilesFullAccessIdoniaConnectScope |
  AcquisitionIdoniaConnectScope |
  NotifyIdoniaConnectScope |
  RemoteSignIdoniaConnectScope |
  ConfigurationModifyIdoniaConnectScope

export const IdoniaFullUserInfoScope = IdoniaBasicUserInfoScope |
  IdoniaPrivateUserInfoScope

export const IdoniaScope = IdoniaFullUserInfoScope |
    AccountModifyIdoniaScope |
    AllFilesFullAccessIdoniaScope |
    IdoniaConnectScope

export const IdoniaAdminPanelScope = AccountEditIdoniaAdminScope |
  OrganizationEditIdoniaAdminScope |
  WhitelabelEditIdoniaAdminScope |
  LicenseEditIdoniaAdminScope |
  ConnectReadIdoniaAdminScope |
  StatisticsReadIdoniaAdminScope |
  RoleEditIdoniaAdminScope |
  AdminIdoniaScope

export default function useScopes () {
  function getScopeName (s = 0) {
    s = BigInt(s)
    switch (s) {
      /* OpenID Connect Standard Scopes */
      case OpenidScope:
        return 'openid'
      case ProfileScope:
        return 'profile'
      case PhoneScope:
        return 'phone'
      case EmailScope:
        return 'email'

      /* OpenID Connect Standard Scopes - Unused */
      case AddressScope:
        return 'address'

      /* Idonia specific scopes */
      case IdoniaBasicUserInfoScope:
        return 'idonia:user'
      case IdoniaPrivateUserInfoScope:
        return 'idonia:user:private'
      case IdoniaFullUserInfoScope:
        return 'idonia:user:full'

      case SingleFolderAddIdoniaScope:
        return 'idonia:folder:add'
      case SingleFolderReadIdoniaScope:
        return 'idonia:folder:read'
      case SingleFolderEditIdoniaScope:
        return 'idonia:folder:edit'
      case SingleFolderShareIdoniaScope:
        return 'idonia:folder:share'
      case SingleFolderDeleteIdoniaScope:
        return 'idonia:folder:delete'
      case SingleFolderFullAccessIdoniaScope:
        return 'idonia:folder:full_access'

      case MySpaceAddIdoniaScope:
        return 'idonia:myspace:add'
      case MySpaceReadIdoniaScope:
        return 'idonia:myspace:read'
      case MySpaceEditIdoniaScope:
        return 'idonia:myspace:edit'
      case MySpaceShareIdoniaScope:
        return 'idonia:myspace:share'
      case MySpaceDeleteIdoniaScope:
        return 'idonia:myspace:delete'
      case MySpaceFullAccessIdoniaScope:
        return 'idonia:myspace:full_access'

      case AllFilesAddIdoniaScope:
        return 'idonia:files:add'
      case AllFilesReadIdoniaScope:
        return 'idonia:files:read'
      case AllFilesEditIdoniaScope:
        return 'idonia:files:edit'
      case AllFilesShareIdoniaScope:
        return 'idonia:files:share'
      case AllFilesDeleteIdoniaScope:
        return 'idonia:files:delete'
      case AllFilesFullAccessIdoniaScope:
        return 'idonia:files:full_access'

      case PublicUrlIdoniaScope:
        return 'idonia:files:share_public'

      /* Idonia connect cloud scopes */
      case AcquireIdoniaConnectScope:
        return 'idonia:connect:acquire'
      case AcquisitionIdoniaConnectScope:
        return 'idonia:connect:acquisition'
      case FilesAddIdoniaConnectScope:
        return 'idonia:connect:add'
      case FilesReadIdoniaConnectScope:
        return 'idonia:connect:read'
      case FilesEditIdoniaConnectScope:
        return 'idonia:connect:edit'
      case FilesShareIdoniaConnectScope:
        return 'idonia:connect:share'
      case FilesDeleteIdoniaConnectScope:
        return 'idonia:connect:delete'
      case NotifyIdoniaConnectScope:
        return 'idonia:connect:notify'
      case RemoteSignIdoniaConnectScope:
        return 'idonia:connect:remote_sign'
      case ConfigurationModifyIdoniaConnectScope:
        return 'idonia:connect:configuration_modify'
      case FilesFullAccessIdoniaConnectScope:
        return 'idonia:connect:full_access'
      case IdoniaConnectScope:
        return 'idonia:connect'
      /* Idonia groups scopes TODO */

      /* Idonia organization scopes TODO */
      /* Idonia admin scopes */
      case AccountEditIdoniaAdminScope:
        return 'idonia:admin:account:edit'
      case OrganizationEditIdoniaAdminScope:
        return 'idonia:admin:organization:edit'
      case LicenseReadIdoniaAdminScope:
        return 'idonia:admin:license:read'
      case LicenseEditIdoniaAdminScope:
        return 'idonia:admin:license:edit'
      case WhitelabelEditIdoniaAdminScope:
        return 'idonia:admin:whitelabel:edit'
      case ConnectReadIdoniaAdminScope:
        return 'idonia:admin:connect:read'
      case ConnectEditIdoniaAdminScope:
        return 'idonia:admin:connect:edit'
      case StatisticsReadIdoniaAdminScope:
        return 'idonia:admin:statistics:read'
      case RoleEditIdoniaAdminScope:
        return 'idonia:admin:role:edit'
      /* Idonia private scopes */
      case AccountModifyIdoniaScope:
        return 'idonia:account'

      case AdminIdoniaScope:
        return 'idonia:platform:admin'

      /* Idonia other scopes */
      case IdoniaScope:
        return 'idonia'

      case IdoniaAdminPanelScope:
        return 'idonia_admin_panel'

      /* Special autogrant scope */
      case AutograntScope:
        return 'autogrant'

      /* Special invalid scope */
      case InvalidScope:
        return 'invalid'
    }
    return 'invalid'
  }

  function parseScope (s = '') {
    const scope = {}
    const scopeParts = s.split(ARGUMENT_START) || []
    if (scopeParts.length === 0) {
      return scope
    }
    const name = scopeParts[0]

    if (scopeParts.length > 1) {
      scope.argument = scopeParts[1].replace(/\)$/, '').split(ARGUMENT_DELIMITER)
    }

    scope.name = getScope(name)
    return scope
  }
  function getScope (name = '') {
    switch (name) {
      /* OpenID Connect Standard Scopes */
      case getScopeName(OpenidScope):
        return OpenidScope

      case getScopeName(ProfileScope):
        return ProfileScope

      case getScopeName(PhoneScope):
        return PhoneScope

      case getScopeName(EmailScope):
        return EmailScope

      /* OpenID Connect Standard Scopes - Unused */
      case getScopeName(AddressScope):
        return AddressScope

      /* Idonia specific scopes */
      case getScopeName(IdoniaBasicUserInfoScope):
        return IdoniaBasicUserInfoScope

      case getScopeName(IdoniaPrivateUserInfoScope):
        return IdoniaPrivateUserInfoScope

      case getScopeName(IdoniaFullUserInfoScope):
        return IdoniaFullUserInfoScope

      case getScopeName(SingleFolderAddIdoniaScope):
        return SingleFolderAddIdoniaScope

      case getScopeName(SingleFolderReadIdoniaScope):
        return SingleFolderReadIdoniaScope

      case getScopeName(SingleFolderEditIdoniaScope):
        return SingleFolderEditIdoniaScope

      case getScopeName(SingleFolderShareIdoniaScope):
        return SingleFolderShareIdoniaScope

      case getScopeName(SingleFolderDeleteIdoniaScope):
        return SingleFolderDeleteIdoniaScope

      case getScopeName(SingleFolderFullAccessIdoniaScope):
        return SingleFolderFullAccessIdoniaScope

      case getScopeName(MySpaceAddIdoniaScope):
        return MySpaceAddIdoniaScope

      case getScopeName(MySpaceReadIdoniaScope):
        return MySpaceReadIdoniaScope

      case getScopeName(MySpaceEditIdoniaScope):
        return MySpaceEditIdoniaScope

      case getScopeName(MySpaceShareIdoniaScope):
        return MySpaceShareIdoniaScope

      case getScopeName(MySpaceDeleteIdoniaScope):
        return MySpaceDeleteIdoniaScope

      case getScopeName(MySpaceFullAccessIdoniaScope):
        return MySpaceFullAccessIdoniaScope

      case getScopeName(AllFilesAddIdoniaScope):
        return AllFilesAddIdoniaScope

      case getScopeName(AllFilesReadIdoniaScope):
        return AllFilesReadIdoniaScope

      case getScopeName(AllFilesEditIdoniaScope):
        return AllFilesEditIdoniaScope

      case getScopeName(AllFilesShareIdoniaScope):
        return AllFilesShareIdoniaScope

      case getScopeName(AllFilesDeleteIdoniaScope):
        return AllFilesDeleteIdoniaScope

      case getScopeName(AllFilesFullAccessIdoniaScope):
        return AllFilesFullAccessIdoniaScope

      case getScopeName(PublicUrlIdoniaScope):
        return PublicUrlIdoniaScope

      /* Idonia connect cloud scopes */
      case getScopeName(AcquireIdoniaConnectScope):
        return AcquireIdoniaConnectScope

      case getScopeName(AcquisitionIdoniaConnectScope):
        return AcquisitionIdoniaConnectScope

      case getScopeName(FilesAddIdoniaConnectScope):
        return FilesAddIdoniaConnectScope

      case getScopeName(FilesReadIdoniaConnectScope):
        return FilesReadIdoniaConnectScope

      case getScopeName(FilesEditIdoniaConnectScope):
        return FilesEditIdoniaConnectScope

      case getScopeName(FilesShareIdoniaConnectScope):
        return FilesShareIdoniaConnectScope

      case getScopeName(FilesDeleteIdoniaConnectScope):
        return FilesDeleteIdoniaConnectScope

      case getScopeName(NotifyIdoniaConnectScope):
        return NotifyIdoniaConnectScope

      case getScopeName(RemoteSignIdoniaConnectScope):
        return RemoteSignIdoniaConnectScope

      case getScopeName(ConfigurationModifyIdoniaConnectScope):
        return ConfigurationModifyIdoniaConnectScope

      case getScopeName(FilesFullAccessIdoniaConnectScope):
        return FilesFullAccessIdoniaConnectScope

      case getScopeName(IdoniaConnectScope):
        return IdoniaConnectScope

      /* Idonia groups scopes TODO */

      /* Idonia organization scopes TODO */

      /* Idonia private scopes */
      case getScopeName(AccountModifyIdoniaScope):
        return AccountModifyIdoniaScope

      case getScopeName(AdminIdoniaScope):
        return AdminIdoniaScope

      /* Idonia other scopes */
      case getScopeName(IdoniaScope):
        return IdoniaScope

      case getScopeName(IdoniaAdminPanelScope):
        return IdoniaAdminPanelScope

      /* Special autogrant scope */
      case getScopeName(AutograntScope):
        return AutograntScope

      default:
        return InvalidScope
    }
  }

  const ARGUMENT_DELIMITER = ','
  const ARGUMENT_START = '('
  const ARGUMENT_END = ')'

  function scopeToString (scope) {
    let stringScope = getScopeName(scope.name)
    if (scope.argument) {
      stringScope += `${ARGUMENT_START +
      (Array.isArray(scope.argument) ? scope.argument.join(ARGUMENT_DELIMITER) : scope.argument) +
      ARGUMENT_END}`
    }
    return stringScope
  }

  function getArgumentList (args) {
    if (typeof args !== 'string') {
      return args
    }
    args = args.replace(/^\(/, '').replace(/\)$/, '')
    return args.split(ARGUMENT_DELIMITER)
  }

  function parseScopeCollection (scopes = []) {
    if (typeof scopes === 'string') {
      scopes = scopes.split(' ')
    }
    const scopeCollection = {
      scopeMask: zero
    }
    scopeCollection.arguments = new Map()
    for (const scope of scopes) {
      const s = parseScope(scope)
      scopeCollection.scopeMask |= s.name
      if (s.argument && s.argument.length > 0) {
        for (let i = 0; i < 64; i++) {
          if ((s.name & BigInt(1 << i)) > zero) {
            scopeCollection.arguments.set(BigInt(1 << i), s.argument)
          }
        }
      }
    }
    return scopeCollection
  }

  function scopeCollectionToString (scopeCollection) {
    const r = []
    for (let i = 0; i < 64; i++) {
      if (!!scopeCollection.scopeMask & BigInt(1 << i) > zero) {
        const scope = {
          name: (1 << i),
          argument: scopeCollection.arguments.get(BigInt(1 << i))
        }
        r.push(scopeToString(scope))
      }
    }
    return r.join(' ')
  }

  function getScopes (scopeCollection) {
    const r = []
    for (let i = 0; i < 64; i++) {
      if (scopeCollection.scopeMask & BigInt(1 << i) > zero) {
        const scope = {
          name: BigInt(1 << i),
          argument: scopeCollection.arguments.get(BigInt(1 << i))
        }
        r.push(scope)
      }
    }
    return r
  }

  function hasAllFromScopeCollection (grantedScopes, targetScopes) {
    if (!grantedScopes || !grantedScopes.scopeMask || !targetScopes || targetScopes.scopeMask) return false
    return targetScopes.scopeMask > zero && (grantedScopes.scopeMask & targetScopes.scopeMask) === targetScopes.scopeMask
  }

  function hasAnyFromScopeCollection (grantedScopes, targetScopes) {
    if (!grantedScopes || !grantedScopes.scopeMask || !targetScopes || targetScopes.scopeMask) return false
    return targetScopes.scopeMask > zero && (grantedScopes.scopeMask & targetScopes.scopeMask) > zero
  }

  function hasAll (grantedScopes, scope) {
    if (!grantedScopes || !grantedScopes.scopeMask || !scope) return false
    return scope > zero && (grantedScopes.scopeMask & scope) === scope
  }

  function hasAny (grantedScopes, scope) {
    if (!grantedScopes || !grantedScopes.scopeMask || !scope) return false
    return scope > zero && (grantedScopes.scopeMask & scope) > zero
  }

  function hasScope (grantedScopes, scope = {}) {
    if (!grantedScopes || !grantedScopes.scopeMask || !scope) return false
    return scope.name > zero && (grantedScopes.scopeMask & scope.name) === scope.name
  }

  function has (grantedScopes, scope = zero) {
    if (!grantedScopes || !grantedScopes.scopeMask || !scope) return false
    return scope > zero && (grantedScopes.scopeMask & scope) === scope
  }

  function scopeCollectionFromJSON (json) {
    const scopeCollection = {
      scopeMask: BigInt(json.scope_mask),
      arguments: new Map()
    }
    for (const key of Object.keys(json.arguments)) {
      scopeCollection.arguments.set(getScope(key), json.arguments[key])
    }
    return scopeCollection
  }

  function getActionsFromScope (scope) {
    switch (scope) {
      case SingleFolderReadIdoniaScope:
      case MySpaceReadIdoniaScope:
      case AllFilesReadIdoniaScope:
      case LicenseReadIdoniaAdminScope:
      case ConnectReadIdoniaAdminScope:
      case StatisticsReadIdoniaAdminScope:
        return ['read']
      case SingleFolderEditIdoniaScope:
      case MySpaceEditIdoniaScope:
      case AllFilesEditIdoniaScope:
      case RoleEditIdoniaAdminScope:
        return ['edit']
      case SingleFolderAddIdoniaScope:
      case MySpaceAddIdoniaScope:
      case AllFilesAddIdoniaScope:
        return ['add']
      case SingleFolderDeleteIdoniaScope:
      case MySpaceDeleteIdoniaScope:
      case AllFilesDeleteIdoniaScope:
        return ['delete']
      case SingleFolderShareIdoniaScope:
      case MySpaceShareIdoniaScope:
      case AllFilesShareIdoniaScope:
        return ['share']
      case SingleFolderFullAccessIdoniaScope:
      case MySpaceFullAccessIdoniaScope:
      case AllFilesFullAccessIdoniaScope:
        return ['read', 'edit', 'add', 'delete', 'share']
      case AccountEditIdoniaAdminScope:
      case OrganizationEditIdoniaAdminScope:
      case WhitelabelEditIdoniaAdminScope:
      case LicenseEditIdoniaAdminScope:
      case ConnectEditIdoniaAdminScope:
        return ['read', 'edit', 'add', 'delete']
      default:
        return []
    }
  }
  const orgAdminScope = WhitelabelEditIdoniaAdminScope |
    ConnectEditIdoniaAdminScope |
    LicenseReadIdoniaAdminScope |
    StatisticsReadIdoniaAdminScope |
    AccountEditIdoniaAdminScope |
    OrganizationEditIdoniaAdminScope

  function resourcesFromScopeCollection (scopeCollection) {
    const resources = {}
    for (const key of scopeCollection.arguments.keys()) {
      const argumentsList = getArgumentList(scopeCollection.arguments.get(key))
      if (hasAny({ scopeMask: SingleFolderFullAccessIdoniaScope }, key)) {
        resources.files = resources.files || {}
        for (const argument of argumentsList) {
          resources.files[argument] = resources.files[argument] || []
          resources.files[argument].push(...getActionsFromScope(key))
        }
      }
      if (hasAny({ scopeMask: orgAdminScope }, key)) {
        resources.organizations = resources.organizations || {}
        for (const argument of argumentsList) {
          resources.organizations[argument] = resources.organizations[argument] || []
          resources.organizations[argument].push(...getActionsFromScope(key))
        }
      }
    }
    return resources
  }

  return {
    getScopeName,
    parseScope,
    scopeToString,
    getArgumentList,
    parseScopeCollection,
    scopeCollectionToString,
    scopeCollectionFromJSON,
    resourcesFromScopeCollection,
    getScopes,
    hasAllFromScopeCollection,
    hasAnyFromScopeCollection,
    hasAll,
    hasAny,
    hasScope,
    has,
    idoniaScopes: {
      OpenidScope,
      ProfileScope,
      PhoneScope,
      EmailScope,
      AddressScope,
      IdoniaBasicUserInfoScope,
      SingleFolderAddIdoniaScope,
      SingleFolderReadIdoniaScope,
      SingleFolderEditIdoniaScope,
      SingleFolderShareIdoniaScope,
      SingleFolderDeleteIdoniaScope,
      MySpaceAddIdoniaScope,
      MySpaceReadIdoniaScope,
      MySpaceEditIdoniaScope,
      MySpaceShareIdoniaScope,
      MySpaceDeleteIdoniaScope,
      AllFilesAddIdoniaScope,
      AllFilesReadIdoniaScope,
      AllFilesEditIdoniaScope,
      AllFilesShareIdoniaScope,
      AllFilesDeleteIdoniaScope,
      PublicUrlIdoniaScope,
      AcquireIdoniaConnectScope,
      AcquisitionIdoniaConnectScope,
      FilesAddIdoniaConnectScope,
      FilesReadIdoniaConnectScope,
      FilesEditIdoniaConnectScope,
      FilesShareIdoniaConnectScope,
      FilesDeleteIdoniaConnectScope,
      NotifyIdoniaConnectScope,
      RemoteSignIdoniaConnectScope,
      ConfigurationModifyIdoniaConnectScope,
      AccountModifyIdoniaScope,
      AccountEditIdoniaAdminScope,
      OrganizationEditIdoniaAdminScope,
      WhitelabelEditIdoniaAdminScope,
      LicenseReadIdoniaAdminScope,
      LicenseEditIdoniaAdminScope,
      ConnectReadIdoniaAdminScope,
      ConnectEditIdoniaAdminScope,
      StatisticsReadIdoniaAdminScope,
      RoleEditIdoniaAdminScope,
      IdoniaPrivateUserInfoScope,
      AdminIdoniaScope,
      AutograntScope,
      InvalidScope,
      SingleFolderFullAccessIdoniaScope,
      MySpaceFullAccessIdoniaScope,
      AllFilesFullAccessIdoniaScope,
      FilesFullAccessIdoniaConnectScope,
      IdoniaConnectScope,
      IdoniaFullUserInfoScope,
      IdoniaScope
    }
  }
}



// WEBPACK FOOTER //
// ./src/commons/scopes.js